import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { StencilProvider, ThemeMode } from "@amzn/stencil-react-components/context";
import { QueryClientProvider } from "./providers/query-client-provider";
import App from "./App";
import "./styles/main.scss";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <StencilProvider themeMode={ThemeMode.Light} mode="dense">
      <QueryClientProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StencilProvider>
  </React.StrictMode>
);
